import React from "react";
import { Helmet } from "react-helmet-async";
import Preloader from "../Global/Preloader";
import Header from "../Global/Header";
import BredCrumb from "../Global/BredCrumb";
import Contact from "../MenContact/Contact";
import Map from "../MenContact/Map";
import Call from "../Menhomeone/Call";
import Footer from "../Global/Footer";
import GoToTop from "../Global/GoToTop";
const Main = () => {
  return (
    <>
      <Helmet>
        <title>Hubungi Kami | Logo Woven Mina</title>
        <meta name="description" content="Hubungi Logo Woven Mina untuk pemesanan label woven, hang tag, satin, nylon, dan katun custom. Konsultasi gratis, respon cepat." />
        <link rel="canonical" href="https://www.logowovenmina.com/contact" />
      </Helmet>
      <Preloader />
      <Header />
      <BredCrumb Title="Contact Us" subtitle="Contact Us" />
      <div className="page_wrapper">
        <Contact />
        <Map />
        {/* <Call /> */}
        <Footer />
        <GoToTop />
      </div>
    </>
  );
};
export default Main;
